import React, { useState, useRef } from 'react'
import { Modal, Box, Typography, Button } from '@mui/material'
import EdSelect from '@/components/forms/EdSelect'
import { useForm } from 'react-hook-form'

interface UploadDocumentModalProps {
  isOpen: boolean
  onClose: () => void
}

// Opzioni per le categorie
const categoryOptions = [
  { label: 'Guide', value: 'guide' },
  { label: 'Normative', value: 'normative' },
  { label: 'Modulistica', value: 'modulistica' },
  { label: 'Template', value: 'template' },
  { label: 'Formazione', value: 'formazione' },
  { label: 'Altro', value: 'altro' },
]

const UploadDocumentModal: React.FC<UploadDocumentModalProps> = ({ isOpen, onClose }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const fileInputRef = useRef<HTMLInputElement>(null)
  
  const { register, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: {
      categoria: '',
    }
  })

  const handleFileSelect = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0])
    }
  }

  const onSubmit = (data: any) => {
    console.log('Form data:', data)
    console.log('Selected file:', selectedFile)
    // Qui implementeresti la logica di upload
    onClose()
  }

  const handleClose = () => {
    setSelectedFile(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
    onClose()
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="upload-document-modal-title"
      aria-describedby="upload-document-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '700px' },
          bgcolor: 'background.paper',
          borderRadius: "3px",
          boxShadow: 24,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
          <div className="flex items-center justify-between">
            <Typography id="upload-document-modal-title" variant="h6" component="h2" sx={{ color: '#4F4F4F', fontWeight: 'bold', fontSize: '20px' }}>
              Nuovo documento utile
            </Typography>
            <span onClick={handleClose} className="cursor-pointer">
              <i className="ri-close-line text-gray-500 text-xl"></i>
            </span>
          </div>
        </Box>

        {/* Content */}
        <Box sx={{ p: 3, flex: 1 }}>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            {/* Categoria Field */}
            <div className="w-2/3">
              <EdSelect
                label="Categoria"
                id="categoria"
                options={categoryOptions}
                placeholder="Seleziona"
                register={register("categoria", {
                  required: "Campo obbligatorio",
                })}
                error={errors.categoria && errors.categoria?.message?.toString()}
                value={watch("categoria")}
              />
            </div>

            {/* File Upload Section */}
            <div className="mt-0">
              <span
               
                onClick={handleFileSelect}
                className="text-[#B80F15] cursor-pointer font-bold text-sm hover:text-[#A00D12] transition-colors flex items-center gap-2 font-medium"
              >
                <span className="text-lg">+</span>
                Aggiungi nuovo file
              </span>
              
              {selectedFile && (
                <div className="mt-2 p-2 bg-gray-50 rounded border">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-700">{selectedFile.name}</span>
                    <span className="text-xs text-gray-500">
                      {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
                    </span>
                  </div>
                </div>
              )}
              
              <input
                ref={fileInputRef}
                type="file"
                onChange={handleFileInput}
                className="hidden"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
              />
            </div>
          </form>
        </Box>

        {/* Footer */}
        <Box sx={{ 
          borderTop: 1, 
          borderColor: 'divider', 
          px: 4,
          py: 2,
          backgroundColor: 'white',
          display: 'flex',
          borderRadius: '0 0 3px 3px',
          justifyContent: 'flex-start',
          gap: 2
        }}>
          <Button
            variant="contained"
            onClick={handleSubmit(onSubmit)}
            sx={{
              backgroundColor: '#B80F15',
              px: 4,
              '&:hover': {
                backgroundColor: '#A00D13',
              },
            }}
          >
            Carica
          </Button>
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{
              backgroundColor: '#E3EBF7',
              color: '#285192',
              textTransform: 'uppercase',
              fontSize: '12px',
              fontWeight: 'medium',
              px: 3,
              py: 1.5,
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#BDBDBD',
              },
            }}
          >
            Annulla
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default UploadDocumentModal
